export interface Step {
  num: string;
  title: string;
  desc: string;
  icon: string;
}

export interface NewsItem {
  date: string;
  tag: string;
  title: string;
  desc: string;
}

export interface GuideCard {
  cover: string;
  tag: string;
  title: string;
  desc: string;
  time: string;
}

export const navLinks = [
  { href: '#quickstart', label: '新手入门' },
  { href: '#guides', label: '使用教程' },
  { href: '#play', label: '进阶玩法' },
  { href: '#tips', label: '设置技巧' },
  { href: '#faq', label: '常见问题' },
];

export const quickSteps: Step[] = [
  {
    num: '01',
    title: '下载并完成安装',
    desc: '按你的设备选择对应安装包，下载后跟随提示一路「下一步」即可。无需任何技术知识，全程不超过三分钟。',
    icon: 'ri-download-cloud-2-line',
  },
  {
    num: '02',
    title: '登录并绑定账号',
    desc: '支持手机号或第三方一键登录。建议顺手开启账号绑定，换设备、重装软件时进度与收藏都能找回来。',
    icon: 'ri-shield-user-line',
  },
  {
    num: '03',
    title: '熟悉主界面入口',
    desc: '顶部是实时热点榜，左侧是专题导航，中间是信息流。花两分钟点一点，入口位置心里就有数了。',
    icon: 'ri-layout-grid-line',
  },
  {
    num: '04',
    title: '完成第一次关注',
    desc: '从你感兴趣的专题和关键词开始，订阅上关心的内容。从此信息流里刷到的，都是你真正想看的话题。',
    icon: 'ri-heart-add-line',
  },
];

export const newsItems: NewsItem[] = [
  {
    date: '09.02',
    tag: '界面更新',
    title: '信息流改版上线',
    desc: '专题导航上移至顶部，卡片间距与字号重排，长文阅读更舒适。',
  },
  {
    date: '08.26',
    tag: '功能新增',
    title: '关键词订阅支持多组规则',
    desc: '一个关键词可叠加时间、来源与强度等多重条件，热门进展不再错过。',
  },
  {
    date: '08.12',
    tag: '性能优化',
    title: '收藏与离线缓存提速',
    desc: '同步与加载速度明显提升，弱网环境下也能顺畅翻阅。',
  },
  {
    date: '07.30',
    tag: '新手引导',
    title: '全新上手引导上线',
    desc: '为第一次打开的朋友准备了更友好的引导流程，帮助大家更快入门。',
  },
];

export const guideCards: GuideCard[] = [
  {
    cover: 'https://readdy.ai/api/search-image?query=Clean%20editorial%20flat%20illustration%20of%20a%20magnifying%20glass%20resting%20above%20a%20neat%20hot-search%20panel%20with%20category%20chips%20and%20headline%20rows%2C%20warm%20cream%20paper%20background%2C%20sage%20green%20and%20soft%20melon%20accents%2C%20minimal%20magazine%20editorial%20style%2C%20soft%20paper%20grain%20texture%2C%20generous%20white%20space%2C%20calm%20and%20modern&width=1000&height=680&seq=tu-search-2026&orientation=landscape',
    tag: '操作指南',
    title: '搜索与浏览：更快找到那个话题',
    desc: '顶部搜索框不只是搜标题。掌握关键词、专题与历史文章三种检索方式，热点再杂也一搜即达。',
    time: '阅读约 6 分钟',
  },
  {
    cover: 'https://readdy.ai/api/search-image?query=Editorial%20flat%20illustration%20of%20a%20subscribed%20feed%20board%20with%20many%20curated%20content%20cards%20and%20a%20highlighted%20follow%20star%20button%2C%20warm%20cream%20paper%20background%2C%20soft%20sage%20green%20with%20single%20coral%20accent%2C%20minimal%20magazine%20aesthetic%2C%20soft%20paper%20texture%2C%20airy%20composition%2C%20calm%20and%20clean&width=1000&height=680&seq=tu-feed-2026&orientation=landscape',
    tag: '使用教程',
    title: '订阅与关注：让信息流只讲你关心的事',
    desc: '把喜欢的专题、栏目与关键词加入订阅。一步步教你建自己的追踪清单，阅读效率翻倍。',
    time: '阅读约 8 分钟',
  },
  {
    cover: 'https://readdy.ai/api/search-image?query=Editorial%20flat%20illustration%20of%20a%20bookmark%20tag%20hanging%20on%20a%20soft%20corkboard%20with%20neatly%20saved%20article%20cards%20and%20an%20offline%20download%20icon%2C%20warm%20cream%20paper%20background%2C%20sage%20green%20and%20amber%20accents%2C%20minimal%20magazine%20editorial%20style%2C%20paper%20texture%2C%20clean%20and%20quiet&width=1000&height=680&seq=tu-save-2026&orientation=landscape',
    tag: '操作指南',
    title: '收藏与离线：通勤路上也能慢慢读',
    desc: '一键收藏、一键下载。没网也能接着读，进度会在你的设备间自动同步，想囤多少都行。',
    time: '阅读约 5 分钟',
  },
  {
    cover: 'https://readdy.ai/api/search-image?query=Editorial%20flat%20illustration%20of%20soft%20speech%20bubbles%20and%20comment%20threads%20arranged%20around%20a%20warm%20discussion%20board%2C%20friendly%20community%20feeling%2C%20warm%20cream%20paper%20background%2C%20soft%20sage%20green%20with%20rose%20accent%2C%20minimal%20magazine%20aesthetic%2C%20paper%20texture%2C%20airy%20and%20calm&width=1000&height=680&seq=tu-talk-2026&orientation=landscape',
    tag: '使用教程',
    title: '评论与互动：找到观点相同的同好',
    desc: '在专题下参与讨论、按热评排序浏览。教你用好互动面板，让每一次围观都更有参与感。',
    time: '阅读约 5 分钟',
  },
];

export const playTitles = ['多来源合并追踪', '定时提醒关键进展', '自定义信息流权重', '数据导出与回顾'];

export const playSteps = [
  {
    num: '01',
    title: '把相关专题合并成一个「追踪板」',
    desc: '一个大事件往往散落在多个专题里。把它们拖进同一个追踪板，一次滑动，全貌尽收眼底。',
  },
  {
    num: '02',
    title: '给时效话题设一条提醒线',
    desc: '赛事、发布会这类进展随时变的话题，可以设定时段提醒。重要节点一到，第一时间推给你。',
  },
  {
    num: '03',
    title: '拖拽调整频道优先级',
    desc: '越爱看的内容排得越靠前。信息流权重由你自己说了算，打开即是想看的那一屏。',
  },
  {
    num: '04',
    title: '把收藏导出成自己的资料库',
    desc: '收藏与阅读轨迹支持一键导出，整理成专题笔记，方便日后回顾与检索。',
  },
];

export const settingsTips = [
  {
    icon: 'ri-notification-3-line',
    title: '通知只留「高优先级」',
    desc: '进设置把普通通知关掉，只保留高优先级提醒，既不错过关键进展，也不会被打扰。',
    tag: '推荐',
  },
  {
    icon: 'ri-contrast-2-line',
    title: '开启护眼阅读模式',
    desc: '夜间会自动切换深色主题、降低蓝光。长时间追更也能舒服一点。',
    tag: '护眼',
  },
  {
    icon: 'ri-delete-bin-6-line',
    title: '每周自动清理缓存',
    desc: '让软件每周自动清一次缓存，为高清图文与离线内容留出充足空间。',
    tag: '省心',
  },
  {
    icon: 'ri-shield-check-line',
    title: '按需关闭个性化推荐',
    desc: '关掉「个性化推荐」后仍可正常阅读，浏览记录不再被用来推送，隐私更安心。',
    tag: '隐私',
  },
];

export const faqs = [
  {
    q: '吃瓜软件都支持哪些设备？',
    a: '覆盖主流手机与电脑系统。安装包会按你的设备自动匹配，官网下载页与软件内「帮助中心」都能找到对应的版本。',
  },
  {
    q: '安装包从哪里下载最安全？',
    a: '只建议从吃瓜软件官网的应用分发页或系统自带应用商店获取。安装后可以顺手在「设置 — 关于」里核对一下版本号是否一致。',
  },
  {
    q: '同一个账号能在多台设备登录吗？',
    a: '可以。登录后收藏、订阅与阅读进度会自动同步，换手机、用电脑都不会丢。异地登录时会有安全提醒，确认是本人操作即可。',
  },
  {
    q: '为什么有时候搜不到某个专题？',
    a: '个别专题可能因内容调整短暂下线，或属于临时热门页面。换个关键词多试一次，或留意一下该话题是否有专门的追踪板入口。',
  },
  {
    q: '软件更新频繁吗？需要手动升级吗？',
    a: '版本会随功能迭代定期更新，默认开启自动升级。你也可以在设置里改成「仅 Wi-Fi 时更新」，节省流量。',
  },
  {
    q: '有问题或建议，怎么联系？',
    a: '在软件内「我的 — 帮助与反馈」提交即可，也可以在页面底部联系我们。正常会在 1–2 个工作日内回复。',
  },
];